import React, { useEffect, useState, useRef, useCallback } from 'react';
import Layout from '../../Layout';
import { Link, useLocation } from 'react-router-dom';
import { Tabs } from 'antd';
import BreadcrumbBlock from '../../components/BreadcrumbBlock/BreadcrumbBlock';
import './CustomerDetail.scss'
import InformationTab from './Tabs/HistoryInformation';
import { useParams, useNavigate } from 'react-router-dom';
import * as customerApi from '../../api/customer/customerApi';
import useToast from '../../hook/useToast';
import { getInfoAccount, IPermissionCustomer } from '../../api/groupPermission/groupPermissionApi';
import { useSelector } from 'react-redux';
import { selectorInfoUser } from '../../store/slices/infoUserSlice';
import { mixGetV2 } from '../../services/mixin'
import PoolingDataHistoryCard from '../../pages/Customers/Tabs/PoolingDataHistoryCard';

const CustomerDetail: React.FC = () => {
  const { id } = useParams();
  const location = useLocation();
  const queryParams = new URLSearchParams(location.search);
  const warehouseId = queryParams.get('id')
  const dataMigration = queryParams.get('data_migration')

  const isCareFeedback = location.state?.isCareFeedback ?? false
  const navigate = useNavigate()
  const pushToast = useToast();

  useEffect(() => {

    return (() => {
      setInfoCustomer(undefined)
    })
  }, []);
  const [infoCustomer, setInfoCustomer] = useState<customerApi.ICustomerDetail_V4>()
  const [permissionCustomerView, setPermissionCustomerView] = useState<IPermissionCustomer>()
  const gInfoCustomer = async () => {
    const result = await customerApi.getInfoCustomer(Number(id))
    if (result?.status) {
      setInfoCustomer(result.data)
    } else {
      pushToast(result?.message, "error")

    }
  }

  //------------------------------------------------
  const [stData, setStData] = useState({
    items: [],
    col: [],
    jsonData: {},
    idUser: 0,
  });
  const [loading, setLoading] = useState(false);
  const isFetchingDetail = useRef(false);
  const isFetchingCols = useRef(false);

  const getDetail = useCallback(async (sokhung: string) => {
    if (isFetchingDetail.current) return;

    isFetchingDetail.current = true;
    setLoading(true);
    try {
      const res = await mixGetV2(`/api/v1/be/maintenance/${sokhung}?type=1`);
      if (res.status) {
        setStData(prev => ({ ...prev, items: res.data.items }));
      }
    } finally {
      setLoading(false);
      isFetchingDetail.current = false;
    }
  }, []);

  useEffect(() => {
    if (id) {
      getDetail(id);
    }
  }, [id, getDetail]);

  // Column Data
  const user = useSelector(selectorInfoUser);
  useEffect(() => {
    let ignore = false;
    async function getcolumn() {
      const [res] = await Promise.all([
        mixGetV2('/api/v1/be/source_column_warehouses?is_active=1'),
      ]);
      if (!ignore && res.status) {
        const temp = [] as any
        res.data.items.map((val: any) => {
          const listSourceIds = [] as any
          val.params_key.map((val: any) => {
            listSourceIds.push(val.source_id)
            return true
          })
          temp.push({ ...val, source_ids: listSourceIds })
          return true
        })
        setStData(prev => ({ ...prev, idUser: Number(user.id) || 0, col: temp }));
      }
    }
    getcolumn();
    return () => { ignore = true; }
    // eslint-disable-next-line
  }, [user.id]);

  return (
    <Layout contentClassName='customer-detail-content'>
      <BreadcrumbBlock
        items={[
          { title: <Link to="/">THACO AUTO CRM</Link>, },
          { title: <Link to="/customer/list">Khách hàng</Link>, },
          { title: <Link to="/customer/pooling-data">Gộp dữ liệu khách hàng</Link>, },

          { title: <Link to="/customer/pooling-data/history">Lịch sử</Link>, },
          { title: 'Thông tin bảo hành - bảo dưỡng', },
        ]}
        title='Thông tin bảo hành - bảo dưỡng'
        backLink={isCareFeedback ? '/analysis-report/vip-customer-care' : '/customer/pooling-data/history'}
      />

      <PoolingDataHistoryCard
        value={{ ...stData }}
        title='Thông tin bảo hành - bảo dưỡng'
        nameTableCache="TbCachePoolingDataHistoryCard"
        listData={stData.items ?? []}
        onChange={(data, type) => {
          if (type === 'newDataJson') {
            setStData(prev => ({ ...prev, jsonData: data }));
          }
        }}
      />
    </Layout>
  );
}

export default CustomerDetail;
